import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import { getServiceBySlug, serviceCategories } from "./ServicesContent";

export default function OneService(props) {
  const { serviceSlug } = props;
  const appContext = useContext(AppContext);
  const service = getServiceBySlug(serviceSlug) || serviceCategories[0];
  const galleryImages = service.galleryImages || [service.heroImage];

  return (
    <>
      <PageHero
        eyebrow="Service"
        title={service.title}
        text={service.summary}
        image={service.heroImage}
      />

      <section className="tgm-section tgm-service-detail">
        <div className="container">
          <div className="tgm-service-detail-layout">
            <MotionGroup className="tgm-service-detail-main" stagger={0.08}>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                {service.navTitle}
              </MotionReveal>
              <MotionText
                as="h2"
                text="Focused support from planning to delivery."
              />
              <MotionReveal as="p" variant="soft">
                {service.intro}
              </MotionReveal>

              <div className="tgm-detail-block">
                <h3>Subservices</h3>
                <div className="tgm-pill-grid">
                  {service.subServices.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </div>

              <div className="tgm-detail-block">
                <h3>How SNJ Supports This Work</h3>
                <MotionGroup className="tgm-highlight-grid" stagger={0.08}>
                  {service.highlights.map((item, index) => (
                    <MotionItem
                      className="tgm-highlight-card"
                      variant="card"
                      key={item}
                    >
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <p>{item}</p>
                    </MotionItem>
                  ))}
                </MotionGroup>
              </div>
            </MotionGroup>

            <MotionReveal
              as="aside"
              className="tgm-service-detail-aside"
              variant="image"
            >
              <img src={service.heroImage} alt={service.title} />
              <div>
                <h3>Ready to discuss this service?</h3>
                <p>
                  Share your project scope with our team so we can help clarify
                  the next practical step.
                </p>
                <button
                  type="button"
                  className="tgm-solid-btn"
                  onClick={() => appContext.navTo({ item: "contact_us" })}
                >
                  Contact us <MdArrowForward />
                </button>
              </div>
            </MotionReveal>
          </div>

          <div className="tgm-service-sample-gallery">
            <MotionGroup className="tgm-section-head" stagger={0.08}>
              <div>
                <MotionReveal
                  as="p"
                  className="tgm-section-kicker"
                  variant="soft"
                >
                  Sample Works
                </MotionReveal>
                <MotionText
                  as="h2"
                  text="Visual references for this service area."
                />
              </div>
              <MotionReveal as="p" variant="soft" delay={0.12}>
                These images give visitors a quick feel for the kind of site
                activity, finishing, and construction scopes connected to this
                service.
              </MotionReveal>
            </MotionGroup>

            <MotionGroup className="tgm-service-sample-grid" stagger={0.08}>
              {galleryImages.map((image, index) => (
                <MotionItem
                  as="figure"
                  variant="image"
                  className="tgm-service-sample-item"
                  key={`${service.slug}-${index}`}
                >
                  <img src={image} alt={`${service.title} sample ${index + 1}`} />
                </MotionItem>
              ))}
            </MotionGroup>
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
